import { useEffect } from 'react';

/**
 * Sets document.title whenever it (the dependency) changes.
 */
const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export { useDocumentTitle };
